// DocumentTherapyTiming.js — Extracted from Document.js
import React from "react";
import TextField from "@mui/material/TextField";
import ReadOnlyDocumentField from "./ReadOnlyDocumentField";

const DocumentTherapyTiming = ({
  documentData,
  isEditingTherapyMinutes,
  setIsEditingTherapyMinutes,
  therapyMinutes,
  setTherapyMinutes,
  therapyMinutesValidation,
  setTherapyMinutesValidation,
  handleTherapyMinutesChange,
  handleTherapyTimeSave,
  isEditingTherapyType,
  setIsEditingTherapyType,
  therapyType,
  setTherapyType,
  mostRecentTherapy,
  isEditable = true,
}) => {
  if (!isEditable) {
    return (
      <div className="standard-container">
        <div className="datetime-header datetime-row">
          <ReadOnlyDocumentField label="Minutes of Therapy" value={documentData.therapyMinutes} />
          <ReadOnlyDocumentField label="Therapy Type" value={documentData.therapyType || mostRecentTherapy?.therapyType} />
        </div>
      </div>
    );
  }
  return (
    <div className="standard-container">
      <div className="datetime-header">
        <div className="document-times therapy-timing-row">
          <TextField
            label="Minutes of Therapy"
            variant="outlined"
            size="small"
            value={isEditingTherapyMinutes ? therapyMinutes : (documentData.therapyMinutes || "")}
            onChange={handleTherapyMinutesChange}
            onFocus={() => {
              setIsEditingTherapyMinutes(true);
              setTherapyMinutes(documentData.therapyMinutes || "");
              setTherapyMinutesValidation({ isValid: null, message: "" });
            }}
            onBlur={() => handleTherapyTimeSave("therapyMinutes", therapyMinutes)}
            error={therapyMinutesValidation.isValid === false}
            helperText={therapyMinutesValidation.isValid === false ? therapyMinutesValidation.message : ""}
            className="therapy-minutes-field"
            slotProps={{
              input: { style: { fontSize: '0.8125rem' } },
              inputLabel: { style: { fontSize: '0.75rem' } },
            }}
          />
          <TextField
            label="Therapy Type"
            variant="outlined"
            size="small"
            value={isEditingTherapyType ? therapyType : (documentData.therapyType || mostRecentTherapy?.therapyType || "")}
            onChange={(e) => setTherapyType(e.target.value)}
            onFocus={() => {
              setIsEditingTherapyType(true);
              setTherapyType(documentData.therapyType || mostRecentTherapy?.therapyType || "");
            }}
            onBlur={() => handleTherapyTimeSave("therapyType", therapyType)}
            className="therapy-type-field"
            slotProps={{
              input: { style: { fontSize: '0.8125rem' } },
              inputLabel: { style: { fontSize: '0.75rem' } },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default React.memo(DocumentTherapyTiming);
